import { BlocksNutritionInformation } from "../../../../__generated__/contentful-types";
import classnames from "classnames/bind";
import styles from "./nutrition-information.module.css";

const cx = classnames.bind(styles);

/**
 * For each key in block.product (eg. "nutritionFat", "nutritionSaturatesInFat")
 * which represents the "value" of that nutritional property, there is an
 * equivalent property on `block` (named eg. "fat", "saturatesInFat",
 * respectively) that represents the localized "title" or "label" of that
 * nutritional property. This represents a map of those relationships.
 */
const nutritionalInformationFactAndTitleKeyPairs = [
  ["nutritionEnergy", "energy"],
  ["nutritionProtein", "protein"],
  ["nutritionCarbohydrates", "carbohydrates"],
  ["nutritionSugarsInCarbohydrates", "sugarsInCarbohydrates"],
  ["nutritionFat", "fat"],
  ["nutritionSaturatesInFat", "saturatesInFat"],
  ["nutritionFibre", "fibre"],
  ["nutritionSodium", "sodium"],
] as const;

export const NutritionInformation = ({
  block,
}: {
  block: BlocksNutritionInformation;
}) => {
  return (
    <div className={cx("container")}>
      <div className={cx("inner")}>
        <div className={cx("main")}>
          <h2 className={cx("card-title")}>{block.title}</h2>
          <span className={cx("card-per")}>{block.per}</span>
          <div className={cx("card")}>
            <dl className={cx("card-table")}>
              {block.product &&
                nutritionalInformationFactAndTitleKeyPairs.map(
                  ([factKey, titleKey]) => {
                    const fact = block.product?.[factKey];
                    const title = block[titleKey];

                    return fact ? (
                      <div
                        key={factKey}
                        className={cx(
                          "card-table-item",
                          (titleKey === "saturatesInFat" ||
                            titleKey === "sugarsInCarbohydrates") &&
                            "card-table-sub-item",
                        )}
                      >
                        <dt
                          className={
                            titleKey === "saturatesInFat" ||
                            titleKey === "sugarsInCarbohydrates"
                              ? ""
                              : cx("card-nutrition-title")
                          }
                        >
                          {title}
                        </dt>
                        <dd className={cx("card-nutrition-fact")}>{fact}</dd>
                      </div>
                    ) : null;
                  },
                )}
            </dl>
            <p className={cx("card-disclaimer")}>{block.disclaimer}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
